function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2c5.523 0 10 4.478 10 10s-4.477 10-10 10c-5.43 0-9.848-4.327-9.996-9.72L2 11.999l.016-.018H1.002c-.83 0-1.14-.566-.69-1.271l1.876-2.939c.448-.702 1.173-.705 1.623 0l1.877 2.939c.449.702.14 1.271-.69 1.271H3.981l.018.018a8.003 8.003 0 007.752 7.997L12 20c4.417 0 8-3.583 8-8A8.001 8.001 0 005.547 7.272L4.424 5.473A9.977 9.977 0 0112 2zm0 4a.75.75 0 01.75.75V8h1a1 1 0 01.117 1.993L13.75 10H11.5a.5.5 0 00-.09.992l.09.008H13a2.5 2.5 0 01.164 4.995L13 16h-.25v1.25a.75.75 0 01-1.5 0V16H10a1 1 0 01-.117-1.993L10 14h3a.5.5 0 00.09-.992L13 13h-1.5a2.5 2.5 0 01-.25-4.988V6.75A.75.75 0 0112 6z",
    fill: "#000"
  }));
}

export var ReactComponent = SvgComponent;
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-subscription.svg";